import { useState, useCallback, useEffect } from "react";
import { SetAuditTrail, SetAuditTrailBulk } from "../../components/Reports/AuditTrailReportEmployeeSetup";
import operationBenefitsService from "../services/operationBenefitsService";

export const useOperationBenefits = ({ user, showGeneralMessage }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const res = await operationBenefitsService.getAll();
      setData(res.data || []);
      setFilterData(res.data || []);
    } catch (err) {
      showGeneralMessage("Failed to load Operation Benefits", false);
    } finally {
      setLoading(false);
    }
  }, [showGeneralMessage]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleAction = async (actionFn, auditData, ...args) => {
    setLoading(true);
    try {
      const res = await actionFn(...args);

      if (Array.isArray(auditData)) await SetAuditTrailBulk({ data: auditData });
      else if (auditData) await SetAuditTrail(auditData);

      showGeneralMessage(res.data?.message || "Saved successfully", true);
      await fetchAll();
      return true; // Return a simple boolean for easier 'if' checks
    } catch (err) {
      console.error("Action Error:", err);

      // Robust message extraction: 
      // 1. Backend custom message { message: "..." }
      // 2. .NET Validation error { errors: { ... } }
      // 3. Simple string
      const errorMsg = err.response?.data?.message
        || err.response?.data
        || "An unexpected error occurred.";

      showGeneralMessage(typeof errorMsg === 'string' ? errorMsg : "Validation Error", false);
      return false; // Return false so the modal stays open
    } finally {
      setLoading(false);
    }
  };

  const searchData = (value) => {
    if (!value) { setData(filterData); return; }
    const lower = value.toLowerCase();
    setData(filterData.filter(f =>
      f.id.toString().includes(lower)
    ));
  };

  return {
    loading, data, searchData,
    createBenefit: (p, audit) => handleAction(operationBenefitsService.create, audit, p),
    updateBenefit: (id, p, audit) => handleAction(operationBenefitsService.update, audit, id, p),
    getBenefitById: (id) => operationBenefitsService.getById(id),
    refresh: fetchAll
  };
};